var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEncyclopedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2525_2551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0017 73.998C57.4353 73.998 74 57.4333 74 36.9997C74 16.5662 57.4353 0.00146484 37.0017 0.00146484C16.5681 0.00146484 0.00341797 16.5662 0.00341797 36.9997C0.00341797 57.4333 16.5681 73.998 37.0017 73.998Z",
    fill: "#4ABC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66297 19.6876V16.7584H6.03123C5.44229 17.6576 4.88786 18.5807 4.37793 19.5323L7.66297 19.6876Z",
    fill: "#357180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1764 19.0316V16.7584H12.4521V19.6831L26.1764 19.0316Z",
    fill: "#357180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3388 16.7584H36.2856V18.5519L48.7242 17.9619V19.7993H50.3225V71.515C51.4156 71.0927 52.4823 70.6218 53.5228 70.1023V17.9421C53.5229 17.2907 52.993 16.7584 52.3388 16.7584Z",
    fill: "#357180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.004 19.7999L12.4525 19.6831V16.7584H7.66309V19.6876L10.004 19.7999Z",
    fill: "#27636D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3234 71.515V19.7999H48.7251V72.0905C49.2631 71.91 49.796 71.7196 50.3234 71.515Z",
    fill: "#D7D7BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66352 19.7999V19.6883L4.37847 19.533C4.33054 19.6205 4.28791 19.7111 4.2417 19.7999H7.66352Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74943 19.7999H10.004L7.66309 19.6876V19.7999H7.74943Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24146 19.7999C3.15243 21.8698 2.25342 24.0524 1.56815 26.3315L5.69444 26.4629C6.39079 26.4857 6.95693 27.0915 6.95693 27.8171C6.95693 28.5426 6.39079 29.1122 5.69444 29.0895L0.890996 28.9365C0.690677 29.8368 0.520023 30.7488 0.386842 31.6729L5.69444 31.843C6.39079 31.8658 6.95693 32.4705 6.95693 33.196C6.95693 33.9216 6.39079 34.4924 5.69444 34.4696L0.109393 34.2913C0.0469394 35.1495 0.00540794 36.0141 0.00244141 36.8881L5.69381 37.0709C6.39017 37.0925 6.95631 37.6984 6.95631 38.424C6.95631 39.1495 6.39017 39.7203 5.69381 39.6976L0.0947162 39.5177C0.15717 40.4478 0.251318 41.3696 0.380908 42.2792L5.69428 42.4492C6.39064 42.472 6.95677 43.0767 6.95677 43.8011C6.95677 44.5279 6.39064 45.0985 5.69428 45.0759L0.859301 44.9216C1.07024 45.8856 1.31443 46.8385 1.59953 47.7732L5.69491 47.9047C6.39126 47.9275 6.9574 48.5322 6.9574 49.2577C6.9574 49.9822 6.39126 50.553 5.69491 50.5302L2.52556 50.4286C2.89544 51.3779 3.29732 52.3116 3.74183 53.2193L5.69491 53.2818C6.39126 53.3046 6.9574 53.9116 6.9574 54.6348C6.9574 55.3604 6.39126 55.93 5.69491 55.9073L5.19013 55.8915C5.94316 57.157 6.77035 58.3709 7.66375 59.5324V19.7999H4.24146Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74945 19.7999H7.66357V59.5335C7.69215 59.5704 7.72134 59.6066 7.74945 59.6433V19.7999Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74951 59.6426C8.39856 60.4804 9.07914 61.2912 9.7972 62.0694V21.1197H10.0041V19.7994H7.74951V59.6426Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1769 19.7999V19.0316L12.4526 19.6832V19.7999H26.1769Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7246 19.7999V17.9625L36.2861 18.5526V19.7999H48.7246Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4529 19.7999V19.6831L10.0044 19.7999H12.3647H12.4529Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.558 52.674L32.2219 49.9639L30.8725 50.0077L29.2676 52.8108L33.558 52.674Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2178 58.1377L36.0951 57.8229L34.832 55.2598L27.7368 55.4861L26.2178 58.1377Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2861 25.7671L44.4206 25.5071C45.1176 25.4843 45.6825 26.0539 45.6825 26.7807C45.6825 27.5062 45.1176 28.1109 44.4206 28.1348L36.2861 28.3937V31.1471L44.4206 30.8871C45.1176 30.8643 45.6825 31.4339 45.6825 32.1596C45.6825 32.8853 45.1176 33.491 44.4206 33.5138L36.2861 33.7737V36.3741L44.4206 36.1153C45.1176 36.0914 45.6825 36.662 45.6825 37.3878C45.6825 38.1135 45.1176 38.718 44.4206 38.7408L36.2861 39.0008V41.7542L44.4206 41.4942C45.1176 41.4714 45.6825 42.0399 45.6825 42.7655C45.6825 43.491 45.1176 44.0981 44.4206 44.1208L36.2861 44.3808V47.2096L44.4206 46.9497C45.1176 46.9269 45.6825 47.4964 45.6825 48.2222C45.6825 48.9454 45.1176 49.5524 44.4206 49.5752L36.2861 49.8341V52.5875L44.4206 52.3275C45.1176 52.3047 45.6825 52.8755 45.6825 53.6C45.6825 54.3256 45.1176 54.9303 44.4206 54.9531L36.2861 55.213V57.8158L44.4206 57.5569C45.1176 57.533 45.6825 58.1037 45.6825 58.8281C45.6825 59.5526 45.1176 60.1595 44.4206 60.1823L14.5266 61.1372C13.8302 61.16 13.2658 60.5892 13.2658 59.8636C13.2658 59.1391 13.8302 58.5334 14.5266 58.5118L26.1763 58.1385V55.5357L14.5266 55.908C13.8302 55.9308 13.2658 55.3612 13.2658 54.6355C13.2658 53.9123 13.8302 53.3052 14.5266 53.2824L26.1763 52.9102V50.1568L14.5266 50.5301C13.8302 50.5529 13.2658 49.9821 13.2658 49.2576C13.2658 48.5321 13.8302 47.9274 14.5266 47.9046L26.1763 47.5324V44.7035L14.5266 45.0758C13.8302 45.0986 13.2658 44.5277 13.2658 43.8009C13.2658 43.0765 13.8302 42.4718 14.5266 42.4491L26.1763 42.0771V39.3238L14.5266 39.6971C13.8302 39.7199 13.2658 39.1491 13.2658 38.4235C13.2658 37.698 13.8302 37.0922 14.5266 37.0705L26.1763 36.6972V34.0968L14.5266 34.4688C13.8302 34.4916 13.2658 33.9208 13.2658 33.1953C13.2658 32.4697 13.8302 31.865 14.5266 31.8422L26.1763 31.4701V28.7167L14.5266 29.0888C13.8302 29.1116 13.2658 28.542 13.2658 27.8163C13.2658 27.0908 13.8302 26.485 14.5266 26.4622L26.1763 26.0901V19.8H12.4526V64.6728C12.7254 64.9147 13 65.1554 13.2798 65.3896C13.2745 65.3406 13.2658 65.2938 13.2658 65.2436C13.2658 64.5204 13.8302 63.9134 14.5266 63.8906L44.4208 62.9354C45.1178 62.9126 45.6826 63.4834 45.6826 64.2066C45.6826 64.9334 45.1178 65.538 44.4208 65.5608L14.6878 66.5113C20.891 71.2078 28.6184 73.9985 36.999 73.9985C41.099 73.9985 45.0389 73.322 48.7241 72.0904V19.7998H36.2862L36.2861 25.7671Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3643 64.5957C12.3935 64.6219 12.4239 64.6459 12.4525 64.6722V19.7999H12.3643V64.5957Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3163 21.1197V62.6136C10.9748 63.2994 11.656 63.9625 12.3647 64.5958V19.7999H10.0044V21.1202H10.3163V21.1197Z",
    fill: "#E7E7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0042 21.1196H9.79736V62.0695C9.86513 62.1437 9.93585 62.2131 10.0042 62.2862V21.1196Z",
    fill: "#DCDDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3163 62.6139V21.1196H10.0044V62.2862C10.1078 62.3972 10.2117 62.5053 10.3163 62.6139Z",
    fill: "#DCDDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95691 27.8163C6.95691 27.0907 6.39077 26.4849 5.69442 26.4622L1.56813 26.3307C1.3116 27.1854 1.08739 28.0547 0.891602 28.9358L5.69504 29.0888C6.39077 29.1116 6.95691 28.542 6.95691 27.8163Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95691 33.1953C6.95691 32.4698 6.39077 31.8651 5.69442 31.8423L0.386824 31.6722C0.262386 32.5363 0.173077 33.4103 0.109375 34.2908L5.69442 34.4689C6.39077 34.4917 6.95691 33.9209 6.95691 33.1953Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95683 38.4235C6.95683 37.6979 6.39069 37.0921 5.69434 37.0704L0.00296653 36.8876C0.002342 36.9249 0 36.9605 0 36.9973C0 37.8462 0.0385649 38.6839 0.0946168 39.5176L5.69434 39.697C6.39069 39.7198 6.95683 39.1496 6.95683 38.4235Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95673 43.8016C6.95673 43.0772 6.39059 42.4725 5.69423 42.4498L0.380859 42.2798C0.508733 43.1719 0.669394 44.0517 0.858783 44.9222L5.69376 45.0764C6.39059 45.0986 6.95673 44.5284 6.95673 43.8016Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95699 49.2577C6.95699 48.5322 6.39085 47.9275 5.6945 47.9047L1.59912 47.7732C1.87314 48.6747 2.18509 49.558 2.52515 50.4284L5.6945 50.53C6.39085 50.5528 6.95699 49.9826 6.95699 49.2577Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95678 54.6354C6.95678 53.9121 6.39064 53.3051 5.69428 53.2823L3.74121 53.2198C4.1876 54.1335 4.67192 55.024 5.1895 55.8921L5.69428 55.9078C6.39064 55.9305 6.95678 55.3615 6.95678 54.6354Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5264 26.4622C13.83 26.485 13.2656 27.0908 13.2656 27.8163C13.2656 28.5419 13.83 29.1115 14.5264 29.0888L26.1761 28.7166V26.09L14.5264 26.4622Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4207 28.1349C45.1177 28.111 45.6825 27.5063 45.6825 26.7807C45.6825 26.0539 45.1177 25.4843 44.4207 25.5071L36.2861 25.7671V28.3937L44.4207 28.1349Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4207 33.5136C45.1177 33.4908 45.6825 32.885 45.6825 32.1595C45.6825 31.4339 45.1177 30.8644 44.4207 30.887L36.2861 31.147V33.7736L44.4207 33.5136Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5264 31.8423C13.83 31.8651 13.2656 32.4698 13.2656 33.1953C13.2656 33.9209 13.83 34.4917 14.5264 34.4689L26.1761 34.0968V31.4702L14.5264 31.8423Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5264 37.0703C13.83 37.0919 13.2656 37.6978 13.2656 38.4234C13.2656 39.1489 13.83 39.7198 14.5264 39.697L26.1761 39.3237V36.697L14.5264 37.0703Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4207 38.7405C45.1177 38.7177 45.6825 38.113 45.6825 37.3875C45.6825 36.6619 45.1177 36.0911 44.4207 36.115L36.2861 36.3743V39.0009L44.4207 38.7405Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4207 44.1206C45.1177 44.0978 45.6825 43.4907 45.6825 42.7652C45.6825 42.0396 45.1177 41.4712 44.4207 41.4939L36.2861 41.7539V44.3805L44.4207 44.1206Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5264 42.4491C13.83 42.4719 13.2656 43.0766 13.2656 43.8009C13.2656 44.5277 13.83 45.0984 14.5264 45.0758L26.1761 44.7035V42.0769L14.5264 42.4491Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4207 49.5748C45.1177 49.552 45.6825 48.945 45.6825 48.2218C45.6825 47.4962 45.1177 46.9265 44.4207 46.9493L36.2861 47.2092V49.8335L44.4207 49.5748Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5264 47.9047C13.83 47.9275 13.2656 48.5322 13.2656 49.2577C13.2656 49.9822 13.83 50.553 14.5264 50.5302L26.1761 50.1569V47.5326L14.5264 47.9047Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6087 48.7201L30.8721 50.0077L32.2215 49.9639L31.6087 48.7201Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4207 54.9525C45.1177 54.9297 45.6825 54.325 45.6825 53.5994C45.6825 52.875 45.1177 52.3043 44.4207 52.3269L36.2861 52.5869V55.2123L44.4207 54.9525Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5264 53.2823C13.83 53.3051 13.2656 53.9122 13.2656 54.6354C13.2656 55.3609 13.83 55.9307 14.5264 55.9079L26.1761 55.5357V52.9103L14.5264 53.2823Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7368 55.486L34.832 55.2598L33.5578 52.6741L29.2674 52.8108L27.7368 55.486Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0948 57.8228L26.2175 58.1377L26.1766 58.2108V58.139L14.5269 58.5123C13.8305 58.5338 13.2661 59.1398 13.2661 59.8641C13.2661 60.5896 13.8305 61.1605 14.5269 61.1377L44.4211 60.1824C45.1181 60.1596 45.683 59.5526 45.683 58.8283C45.683 58.104 45.1181 57.5332 44.4211 57.5571L36.2866 57.8159V58.2108L36.0948 57.8228Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5265 66.5148L14.6878 66.5101C14.2094 66.1472 13.7402 65.7728 13.2798 65.3884C13.351 66.0426 13.8786 66.5369 14.5265 66.5148Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4206 65.56C45.1176 65.5372 45.6825 64.9325 45.6825 64.2059C45.6825 63.4826 45.1176 62.9118 44.4206 62.9346L14.5264 63.8898C13.83 63.9126 13.2656 64.5197 13.2656 65.2429C13.2656 65.2932 13.275 65.3399 13.2797 65.3889C13.7401 65.7733 14.2091 66.1478 14.6877 66.5105L44.4206 65.56Z",
    fill: "#B9B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2865 16.7356H26.1768V16.7584H36.2865V16.7356Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2859 18.5526V16.7584H26.1768V19.0316L36.2859 18.5526Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 19.7998H36.2859V18.5525L26.1768 19.0315V19.7998Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8722 50.0078L26.1768 50.1568V52.9102L29.2673 52.8109L30.8722 50.0078Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2859 25.767V19.7999H26.1768V26.0901L36.2859 25.767Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 36.6971L36.2859 36.3745V33.7737L26.1768 34.0967V36.6971Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 42.0771L36.2859 41.7545V39.0011L26.1768 39.3237V42.0771Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 31.47L36.2859 31.147V28.3936L26.1768 28.7166V31.47Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5577 52.6741L36.286 52.5878V49.8344L32.2217 49.9639L33.5577 52.6741Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7367 55.486L26.1768 55.5357V58.1389L26.2177 58.1376L27.7367 55.486Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 47.5325L36.2859 47.2094V44.3812L26.1768 44.7038V47.5325Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0951 57.8228L36.2861 57.8158V55.2131L34.832 55.2598L36.0951 57.8228Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 28.7166L36.2859 28.3936V25.767L26.1768 26.09V28.7166Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 34.0966L36.2859 33.7736V31.147L26.1768 31.47V34.0966Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 39.3237L36.2859 39.0011V36.3745L26.1768 36.6971V39.3237Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 44.7037L36.2859 44.3812V41.7545L26.1768 42.0771V44.7037Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 50.1567L30.8722 50.0077L31.6088 48.7201L32.2216 49.9639L36.2859 49.8343V47.2094L26.1768 47.5324V50.1567Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8318 55.2597L36.2859 55.213V52.5876L33.5576 52.674L34.8318 55.2597Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2673 52.8108L26.1768 52.9101V55.5356L27.7367 55.486L29.2673 52.8108Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2177 58.1376L26.1768 58.1389V58.2107L26.2177 58.1376Z",
    fill: "#BB5538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2857 58.2107V57.8158L36.0947 57.8228L36.2857 58.2107Z",
    fill: "#BB5538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2525_2551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncyclopedia);
export default __webpack_public_path__ + "static/media/encyclopedia.d99cec9479d9a0cb9f3c549e28c4585c.svg";
export { ForwardRef as ReactComponent };